import i18n from '@/i18n'
import { hasFeature } from './entitlements'
// Built lazily: the titles are translated, and i18n.locale is only final once
// the signed-in user's preference has been applied. Call getUserRoles().
const getUserRoles = () => ([
  {
    title: i18n.t('core.sales'),
    menus: [
      {
        name: "Dashboard",
        items: [
          {
            title: i18n.t('utils.dashboardPermission'),
            data: [
              {
                key: "DASHBOARD_VIEW",
                name: "View",
                value: false,
              },
            ],
          },
        ],
      },
      {
        name: "Customer",
        items: [
          {
            title: i18n.t('utils.activeCustomerPermission'),
            data: [
              {
                key: "CUSTOMER_VIEW",
                name: "Customer View",
                value: false,
              },
              {
                key: "CUSTOMER_ADD",
                name: "Customer Add",
                value: false,
              },
              {
                key: "CUSTOMER_EDIT",
                name: "Customer Edit",
                value: false,
              },
              {
                key: "CUSTOMER_DELETE",
                name: "Customer Delete",
                value: false,
              },
              {
                key: "CUSTOMER_RESTORE",
                name: "Customer Restore",
                value: false,
              },
              {
                key: "CUSTOMER_SALES_ORDER_VIEW",
                name: "Sales Order View",
                value: false,
              },
              {
                key: "CUSTOMER_SALES_ORDER_ADD",
                name: "Sales Order Add",
                value: false,
              },
              {
                key: "CUSTOMER_SALES_ORDER_DELETE",
                name: "Sales Order Delete",
                value: false,
              },
              {
                key: "CUSTOMER_SALES_ORDER_UPDATE",
                name: "Sales Order Update",
                value: false,
              },
              {
                key: "CUSTOMER_PAUSE_VIEW",
                name: "Pause View",
                value: false,
              },
              {
                key: "CUSTOMER_DISLIKE_VIEW",
                name: "Dislike View",
                value: false,
              },
              {
                key: "CUSTOMER_ALLERGIES_VIEW",
                name: "Allergies View",
                value: false,
              },
              {
                key: "CUSTOMER_MEAL_VIEW",
                name: "Meal Section View",
                value: false,
              },
              {
                key: "CUSTOMER_MEAL_RATING_VIEW",
                name: "Meal Rating View",
                value: false,
              },
              {
                key: "CUSTOMER_DIETITIAN_VIEW",
                name: "Dietitian View",
                value: false,
              },
              {
                key: "CUSTOMER_DELIVERY_SCHEDULE_VIEW",
                name: "Delivery Schedule View",
                value: false,
              },
              {
                key: "CUSTOMER_PAYMENT_VIEW",
                name: "Customer Payment View",
                value: false,
              },
              {
                key: "CUSTOMER_HEALTH_INFO_VIEW",
                name: "Customer Health Info View",
                value: false,
              },
              {
                key: "CUSTOMER_HEALTH_INFO_ADD",
                name: "Customer Health Info Add",
                value: false,
              },
              {
                key: "CUSTOMER_HEALTH_INFO_EDIT",
                name: "Customer Health Info Edit",
                value: false,
              },
            ],
          },
          {
            title: i18n.t('utils.inactiveCustomerPermission'),
            data: [
              {
                key: "IN_ACTIVE_CUSTOMER_VIEW",
                name: "Customer View",
                value: false,
              },]
          },
          {
            title: i18n.t('utils.customerWithoutMealPermission'),
            data: [
              {
                key: "CUSTOMER_WITHOUT_MEAL_VIEW",
                name: "Customer Without Meal",
                value: false,
              },]
          },
          {
            title: i18n.t('utils.customerBirthdayReport'),
            data: [
              {
                key: "CUSTOMER_BIRTHDAY_REPORT_VIEW",
                name: "Customer Birthday Report",
                value: false,
              },]
          },
          {
            title: i18n.t('utils.paymentOptionPermission'),
            data: [
              {
                key: "PAYMENT_OFFLINE",
                name: "Payment Offline",
                value: false
              },
              {
                key: "PAYMENT_ONLINE",
                name: "Payment Online",
                value: false
              },
              {
                key: "PAYMENT_FREE",
                name: "Payment Free",
                value: false
              },
              {
                key: "PAYMENT_PAY_LATER",
                name: "Payment Pay Later",
                value: false
              },
              {
                key: "REFUND_REPORT",
                name: "Refund Report",
                value: false
              },
            ]
          }
        ],
      },
      {
        name: "Sales Order",
        items: [
          {
            title: i18n.t('utils.salesOrderPermission'),
            data: [
              {
                key: "SALES_ORDER_VIEW",
                name: "View",
                value: false,
              },
              {
                key: "SALES_ORDER_EXPORT",
                name: "Export",
                value: false,
              },
            ],
          },
          {
            title: i18n.t('utils.salesOrderDayWisePermission'),
            data: [
              {
                key: "SALES_ORDER_DAY_WISE_VIEW",
                name: "View",
                value: false,
              }
            ],
          },
          {
            title: i18n.t('orders.endDateReminder'),
            data: [
              {
                key: "END_DATE_REMINDER_VIEW",
                name: "View",
                value: false,
              }
            ],
          },
          {
            title: i18n.t('orders.salesOrderDiscount'),
            data: [
              {
                key: "SALES_ORDER_DISCOUNT",
                name: "View",
                value: false,
              }
            ],
          },
          {
            title: i18n.t('orders.inactiveSalesOrders'),
            data: [
              {
                key: "INACTIVE_SALES_ORDER_VIEW",
                name: "View",
                value: false,
              }
            ],
          },
          {
            title: i18n.t('orders.inactiveSalesOrderCount'),
            data: [
              {
                key: "INACTIVE_SALES_ORDER_COUNT_VIEW",
                name: "View",
                value: false,
              }
            ],
          },
        ],
      },
      {
        name: "Payment",
        items: [
          {
            title: i18n.t('utils.paymentPermission'),
            data: [
              {
                key: "PAYMENT_VIEW",
                name: "View",
                value: false,
              },
              { key: "TAX_SETTINGS", name: "Tax Settings", value: false },
            ],
          },
        ],
      },
      {
        name: "Meals Rating",
        items: [
          {
            title: i18n.t('utils.mealsRatingPermission'),
            data: [
              {
                key: "MEALS_RATING_VIEW",
                name: "View",
                value: false,
              },
            ],
          },
        ],
      },
      {
        name: "Push Notification",
        items: [
          {
            title: i18n.t('utils.pushNotificationPermission'),
            data: [
              {
                key: "PUSH_NOTIFICATION_VIEW",
                name: "View",
                value: false,
              },
              {
                key: "PUSH_NOTIFICATION_SEND",
                name: "Send",
                value: false,
              },
            ],
          },
        ],
      },

    ],
  },
  {
    title: i18n.t('utils.operations'),
    menus: [
      {
        name: "Stocks",
        items: [
          {
            title: i18n.t('utils.stockPermission'),
            data: [
              {
                name: "View",
                key: "STOCK_VIEW",
                value: false,
              },
              {
                name: "Inward View",
                key: "STOCK_INWARD_VIEW",
                value: false,
              },
              {
                name: "Outward View",
                key: "STOCK_OUTWARD_VIEW",
                value: false,
              },
              {
                name: "Current View",
                key: "STOCK_CURRENT_VIEW",
                value: false,
              },

            ],
          },
          {
            title: i18n.t('utils.purchasePermission'),
            data: [
              {
                name: "View",
                key: "PURCHASE_VIEW",
                value: false,
              },
              {
                name: "Add",
                key: "PURCHASE_ADD",
                value: false,
              },
              {
                name: "Submit",
                key: "PURCHASE_SUBMIT",
                value: false,
              }
            ],
          },
          {
            title: i18n.t('utils.adjustStockPermission'),
            data: [
              {
                name: "View",
                key: "ADJUST_STOCK_VIEW",
                value: false,
              },
              {
                name: "Adjust",
                key: "ADJUST_STOCK",
                value: false,
              }
            ],
          },
          {
            title: i18n.t('utils.supplierStockPermission'),
            data: [
              {
                name: "View",
                key: "SUPPLIER_STOCK_VIEW",
                value: false,
              },
              {
                name: "ADD",
                key: "SUPPLIER_STOCK_ADD",
                value: false,
              },
              {
                name: "EDIT",
                key: "SUPPLIER_STOCK_EDIT",
                value: false,
              },
              {
                name: "EDIT",
                key: "SUPPLIER_STOCK_DELETE",
                value: false,
              }
            ],
          },
          {
            title: i18n.t('utils.brandStockPermission'),
            data: [
              {
                name: "View",
                key: "BRAND_STOCK_VIEW",
                value: false,
              },
              {
                name: "ADD",
                key: "BRAND_STOCK_ADD",
                value: false,
              },
              {
                name: "EDIT",
                key: "BRAND_STOCK_EDIT",
                value: false,
              }
            ],
          },
          {
            title: i18n.t('utils.unitStockPermission'),
            data: [
              {
                name: "View",
                key: "UNIT_STOCK_VIEW",
                value: false,
              },
              {
                name: "ADD",
                key: "UNIT_STOCK_ADD",
                value: false,
              },
              {
                name: "EDIT",
                key: "UNIT_STOCK_EDIT",
                value: false,
              }
            ],
          },
          {
            title: i18n.t('utils.masterDataPermission'),
            data: [
              {
                name: "View",
                key: "MASTER_DATA_VIEW",
                value: false,
              },
              {
                name: "Add",
                key: "MASTER_DATA_ADD",
                value: false,
              },
              {
                name: "Edit",
                key: "MASTER_DATA_EDIT",
                value: false,
              },
              {
                name: "Delete",
                key: "MASTER_DATA_DELETE",
                value: false,
              },
            ],
          },
          {
            title: i18n.t('utils.monthlyUsagePermission'),
            data: [
              {
                name: "View",
                key: "MONTHLY_USAGE_VIEW",
                value: false,
              },
            ],
          },
          {
            title: i18n.t('utils.monthlyPurchasePermission'),
            data: [
              {
                name: "View",
                key: "MONTHLY_PURCHASE_VIEW",
                value: false,
              },
            ],
          },
        ],
      },
      {
        name: "Plans",
        items: [
          {
            title: i18n.t('utils.planPermission'),
            data: [
              {
                key: "PLAN_VIEW",
                name: "View",
                value: false,
              },
              {
                key: "PLAN_ADD",
                name: "Add",
                value: false,
              },
              {
                key: "PLAN_EDIT",
                name: "Edit",
                value: false,
              },
              {
                key: "PLAN_DELETE",
                name: "Delete",
                value: false,
              },
              {
                key: "PLAN_DUPLICATE",
                name: "Duplicate",
                value: false,
              },
            ],
          },
        ],
      },
      {
        name: "Meals",
        items: [
          {
            title: i18n.t('utils.mealPermission'),
            data: [
              {
                name: "View Meals",
                key: "MEAL_VIEW",
                value: false,
              },
              {
                name: "Add Meals",
                key: "MEAL_ADD",
                value: false,
              },
              {
                name: "Edit Meals",
                key: "MEAL_EDIT",
                value: false,
              },
              {
                name: "Duplicate Meals",
                key: "MEAL_DUPLICATE",
                value: false,
              },
              {
                name: "Delete Meals",
                key: "MEAL_DELETE",
                value: false,
              },
              {
                name: "Export Meals",
                key: "MEAL_EXPORT",
                value: false,
              },
              {
                name: "Status Change",
                key: "MEAL_STATUS",
                value: false,
              },
              {
                name: "Meal Details",
                key: "MEAL_DETAILS_VIEW",
                value: false,
              },
            ],
          },
        ],
      },
      {
        name: "Meals Category",
        items: [
          {
            title: i18n.t('utils.mealsCategoryPermission'),
            data: [
              {
                key: "MEALS_CATEGORY_VIEW",
                name: "View",
                value: false,
              },
              {
                key: "MEALS_CATEGORY_ADD",
                name: "Add",
                value: false,
              },
              {
                key: "MEALS_CATEGORY_EDIT",
                name: "Edit",
                value: false,
              },
              {
                key: "MEALS_CATEGORY_DELETE",
                name: "Delete",
                value: false,
              },
            ],
          },
        ],
      },
      {
        name: "Diet Plan",
        items: [
          {
            title: i18n.t('utils.dietPlanPermission'),
            data: [
              {
                key: "DIET_PLAN_VIEW",
                name: "View",
                value: false,
              },
              {
                key: "DIET_PLAN_ADD",
                name: "Add",
                value: false,
              },
              {
                key: "DIET_PLAN_EDIT",
                name: "Edit",
                value: false,
              },
              {
                key: "DIET_PLAN_DELETE",
                name: "Delete",
                value: false,
              },
            ],
          },
        ],
      },
      {
        name: "Shop",
        items: [
          {
            title: i18n.t('utils.shopProductCategoryPermissions'),
            data: [
              {
                key: "SHOP_PRODUCT_VIEW",
                name: "View",
                value: false,
              },
              {
                key: "SHOP_PRODUCT_ADD",
                name: "Add",
                value: false,
              },
              {
                key: "SHOP_PRODUCT_EDIT",
                name: "Edit",
                value: false,
              },
              {
                key: "SHOP_PRODUCT_DELETE",
                name: "Delete",
                value: false,
              },

            ],
          },
          {
            title: i18n.t('utils.shopOrderPermissions'),
            data: [

              {
                key: "SHOP_ORDER_VIEW",
                name: "View",
                value: false,
              },
              {
                key: "SHOP_ORDER_PLACE",
                name: "Create Order",
                value: false,
              },
              {
                key: "SHOP_ORDER_UPDATE",
                name: "Edit",
                value: false,
              },
            ],
          },
        ],
      },
      {
        name: "Dietitian Appointments",
        items: [
          {
            title: i18n.t('utils.dietitianAppointmentPermission'),
            data: [
              {
                key: "DIETITIAN_APPOINTMENT_VIEW",
                name: "View",
                value: false,
              },
              {
                key: "DIETITIAN_APPOINTMENT_EDIT",
                name: "Edit",
                value: false,
              },
              {
                key: "DIETITIAN_APPOINTMENT_DELETE",
                name: "Delete",
                value: false,
              },
            ],
          },
        ],
      },
      {
        name: "Dietitian Plan Suggestion",
        items: [
          {
            title: i18n.t('utils.dietitianPlanSuggestion'),
            data: [
              {
                key: "DIETITIAN_PLAN_SUGGESTION",
                name: "Edit",
                value: false,
              },
            ],
          },
        ],
      },
      {
        name: "Universal Pauses",
        items: [
          {
            title: i18n.t('utils.universalPausesPermission'),
            data: [
              {
                key: "UNIVERSAL_PAUSE_VIEW",
                name: "View",
                value: false,
              },
              {
                key: "UNIVERSAL_PAUSE_ADD",
                name: "Add",
                value: false,
              },
              {
                key: "UNIVERSAL_PAUSE_DELETE",
                name: "Delete",
                value: false,
              },
            ],
          },
        ],
      },
      {
        name: "Plan Switch",
        items: [
          {
            title: i18n.t('utils.planSwitchPermission'),
            data: [
              {
                key: "PLAN_SWITCH_VIEW",
                name: "View",
                value: false,
              },
              {
                key: "PLAN_SWITCH_ADD",
                name: "Add",
                value: false,
              },
              {
                key: "PLAN_SWITCH_DELETE",
                name: "Delete",
                value: false,
              },
              {
                key: "SWITCH_PLAN",
                name: "Switch Plan",
                value: false,
              },
            ],
          },
        ],
      },
      {
        name: "Users",
        items: [
          {
            title: i18n.t('utils.managerPermission'),
            data: [
              {
                key: "MANAGER_VIEW",
                name: "View",
                value: false,
              },
              {
                key: "MANAGER_ADD",
                name: "Add",
                value: false,
              },
              {
                key: "MANAGER_EDIT",
                name: "Edit",
                value: false,
              },
              {
                key: "MANAGER_DELETE",
                name: "Delete",
                value: false,
              },
              {
                key: "PERMISSION_VIEW",
                name: "View Permissions",
                value: false,
              },
              {
                key: "PERMISSION_ADD",
                name: "Add Permissions",
                value: false,
              },
              {
                key: "PERMISSION_EDIT",
                name: "Edit Permissions",
                value: false,
              },
              {
                key: "PERMISSION_DELETE",
                name: "Delete Permissions",
                value: false,
              },
            ],
          },
          {
            title: i18n.t('utils.adminPermission'),
            data: [
              {
                key: "ADMIN_VIEW",
                name: "View",
                value: false,
              },
              {
                key: "ADMIN_ADD",
                name: "Add",
                value: false,
              },
              {
                key: "ADMIN_EDIT",
                name: "Edit",
                value: false,
              },
              {
                key: "ADMIN_DELETE",
                name: "Delete",
                value: false,
              },
            ],
          },
          {
            title: i18n.t('utils.driverPermission'),
            data: [
              {
                key: "DRIVER_VIEW",
                name: "View",
                value: false,
              },
              {
                key: "DRIVER_ADD",
                name: "Add",
                value: false,
              },
              {
                key: "DRIVER_EDIT",
                name: "Edit",
                value: false,
              },
              {
                key: "DRIVER_DELETE",
                name: "Delete",
                value: false,
              },
            ],
          },
          {
            title: i18n.t('utils.dietitianPermission'),
            data: [
              {
                key: "DIETITIAN_VIEW",
                name: "View",
                value: false,
              },
              {
                key: "DIETITIAN_ADD",
                name: "Add",
                value: false,
              },
              {
                key: "DIETITIAN_EDIT",
                name: "Edit",
                value: false,
              },
              {
                key: "DIETITIAN_DELETE",
                name: "Delete",
                value: false,
              },
              {
                key: "DIETITIAN_SETTINGS",
                name: "Settings",
                value: false,
              },
            ],
          },
          // {
          //     title: "Celebrity Permission",
          //     data: [
          //         {
          //             key: "CELEBRITY_VIEW",
          //             name: "View",
          //             value: false,
          //         },
          //         {
          //             key: "CELEBRITY_ADD",
          //             name: "Add",
          //             value: false,
          //         },
          //         {
          //             key: "CELEBRITY_EDIT",
          //             name: "Edit",
          //             value: false,
          //         },
          //         {
          //             key: "CELEBRITY_DELETE",
          //             name: "Delete",
          //             value: false,
          //         },
          //     ],
          // },
        ],
      },
      {
        name: "Location",
        items: [
          {
            title: i18n.t('utils.locationPermission'),
            data: [
              {
                key: "LOCATION_VIEW",
                name: "View",
                value: false,
              },
              {
                key: "LOCATION_ADD",
                name: "Add",
                value: false,
              },
              {
                key: "LOCATION_EDIT",
                name: "Edit",
                value: false,
              },
              {
                key: "LOCATION_DELETE",
                name: "Delete",
                value: false,
              },
            ],
          },
        ],
      },
      {
        name: "Region",
        items: [
          {
            title: i18n.t('utils.regionPermission'),
            data: [
              { key: "REGION_VIEW", name: "View", value: false },
              { key: "REGION_ADD", name: "Add", value: false },
              { key: "REGION_EDIT", name: "Edit", value: false },
              { key: "REGION_DELETE", name: "Delete", value: false },
            ],
          },
        ],
      },
      {
        name: "Tags",
        items: [
          {
            title: i18n.t('utils.customerTagPermission'),
            data: [
              {
                key: "CUSTOMER_TAG_VIEW",
                name: "View",
                value: false,
              },
              {
                key: "CUSTOMER_TAG_ADD",
                name: "Add",
                value: false,
              },
              {
                key: "CUSTOMER_TAG_EDIT",
                name: "Edit",
                value: false,
              },
              {
                key: "CUSTOMER_TAG_DELETE",
                name: "Delete",
                value: false,
              },
            ],
          },
          {
            title: i18n.t('utils.mealTagPermission'),
            data: [
              {
                key: "MEAL_TAG_VIEW",
                name: "View",
                value: false,
              },
              {
                key: "MEAL_TAG_ADD",
                name: "Add",
                value: false,
              },
              {
                key: "MEAL_TAG_EDIT",
                name: "Edit",
                value: false,
              },
              {
                key: "MEAL_TAG_DELETE",
                name: "Delete",
                value: false,
              },
            ],
          },
        ],
      },
      {
        name: "Referrals",
        items: [
          {
            title: i18n.t('utils.referralsPermission'),
            data: [
              {
                key: "REFERRAL_VIEW",
                name: "View",
                value: false,
              },
              {
                key: "REFERRAL_SETTINGS",
                name: "Referral Settings",
                value: false,
              },

            ],
          },
        ],
      },
      {
        name: "Faq",
        items: [
          {
            title: i18n.t('utils.faqPermission'),
            data: [
              {
                key: "FAQ_VIEW",
                name: "View",
                value: false,
              },
              {
                key: "FAQ_ADD",
                name: "Add",
                value: false,
              },
              {
                key: "FAQ_EDIT",
                name: "Edit",
                value: false,
              },
              {
                key: "FAQ_DELETE",
                name: "Delete",
                value: false,
              },
            ],
          },
        ],
      },
      {
        name: "Contact Method",
        items: [
          {
            title: i18n.t('utils.contactPermission'),
            data: [
              {
                key: "CONTACT_VIEW",
                name: "View",
                value: false,
              },
              {
                key: "CONTACT_ADD",
                name: "Add",
                value: false,
              },
              {
                key: "CONTACT_EDIT",
                name: "Edit",
                value: false,
              },
              {
                key: "CONTACT_DELETE",
                name: "Delete",
                value: false,
              },
            ],
          },
        ],
      },
      {
        name: "Promo Code",
        items: [
          {
            title: i18n.t('utils.promocodePermission'),
            data: [
              {
                key: "PROMO_CODE_VIEW",
                name: "View",
                value: false,
              },
              {
                key: "PROMO_CODE_ADD",
                name: "Add",
                value: false,
              },
              {
                key: "PROMO_CODE_EDIT",
                name: "Edit",
                value: false,
              },
              {
                key: "PROMO_CODE_DELETE",
                name: "Delete",
                value: false,
              },
            ],
          },
        ],
      },
      {
        name: "Offers",
        items: [
          {
            title: i18n.t('utils.offerPermission'),
            data: [
              {
                key: "OFFER_VIEW",
                name: "View",
                value: false,
              },
              {
                key: "OFFER_ADD",
                name: "Add",
                value: false,
              },
              {
                key: "OFFER_EDIT",
                name: "Edit",
                value: false,
              },
              {
                key: "OFFER_DELETE",
                name: "Delete",
                value: false,
              },
            ],
          },
        ],
      },

    ],
  },
  {
    title: i18n.t('utils.reports'),
    menus: [
      {
        name: "Generations",
        items: [
          {
            title: i18n.t('utils.orderedItemsPermission'),
            data: [
              {
                key: "ORDER_ITEM_VIEW",
                name: "View",
                value: false,
              },
              {
                key: "GENERATE_ITEMS",
                name: "Generate",
                value: false,
              },
            ],
          },
          {
            title: i18n.t('utils.ingredientPermission'),
            data: [
              {
                key: "INGREDIENT_VIEW",
                name: "View",
                value: false,
              },

            ],
          },
          {
            title: i18n.t('utils.deliveryReportPermission'),
            data: [
              {
                key: "DELIVERY_REPORT_VIEW",
                name: "View",
                value: false,
              },
              {
                key: "DELIVERY_REPORT_GENERATE",
                name: "Generate",
                value: false,
              },
              {
                key: "DELIVERY_REPORT_REGENERATE",
                name: "Regenerate",
                value: false,
              },
              {
                key: "DELIVERY_STATUS_UPDATE",
                name: "Mark Delivered",
                value: false,
              }
            ],
          },
          {
            title: i18n.t('utils.setMenuReportPermission'),
            data: [
              {
                key: "SET_MENU_REPORT_VIEW",
                name: "View",
                value: false,
              }
            ],
          },
          {
            title: i18n.t('utils.quickViewDeliveryReportPermission'),
            data: [
              {
                key: "QUICK_DELIVERY_REPORT_VIEW",
                name: "View",
                value: false,
              },
              {
                key: "QUICK_VIEW_GENERATE",
                name: "Generate",
                value: false,
              },
              {
                key: "QUICK_VIEW_REGENERATE",
                name: "Regenerate",
                value: false,
              }
            ],
          },
        ],
      },
      {
        name: "Sales",
        items: [
          {
            title: i18n.t('utils.salesReportPermission'),
            data: [
              {
                key: "SALES_REPORT_VIEW",
                name: "View",
                value: false,
              },
            ],
          },
        ],
      },
      {
        name: "Driver",
        items: [
          {
            title: i18n.t('utils.driverReportPermission'),
            data: [
              {
                key: "DRIVER_REPORT_VIEW",
                name: "View",
                value: false,
              },
            ],
          },
        ],
      },
      {
        name: "PromoCode",
        items: [
          {
            title: i18n.t('utils.promocodeReportPermission'),
            data: [
              {
                key: "PROMO_CODE_REPORT_VIEW",
                name: "View",
                value: false,
              },
            ],
          },
        ],
      },
      {
        name: "Plan Transfer",
        items: [
          {
            title: i18n.t('utils.planTransferPermission'),
            data: [
              {
                key: "PLAN_TRANSFER_LIST",
                name: "View",
                value: false,
              },
            ],
          },
        ],
      },
      {
        name: "Paused/No Meals",
        items: [
          {
            title: i18n.t('utils.pausedNoMealsReportPermission'),
            data: [
              {
                key: "PAUSED_MEALS_REPORT_VIEW",
                name: "View",
                value: false,
              },
            ],
          },
        ],
      },
      {
        name: "Monthly Sales",
        items: [
          {
            title: i18n.t('utils.monthlySalesReportPermission'),
            data: [
              {
                key: "MONTHLY_SALES_VIEW",
                name: "View",
                value: false,
              },
            ],
          },
        ],
      },
      {
        name: "Dietitian Appointments",
        items: [
          {
            title: i18n.t('utils.dietitianAppointmentsReportPermission'),
            data: [
              {
                key: "DIETITIAN_APPOINTMENTS_REPORT",
                name: "View",
                value: false,
              },
            ],
          },
        ],
      },
      {
        name: "Report Export Status",
        items: [
          {
            title: i18n.t('utils.reportExportStatus'),
            data: [
              {
                key: "EXPORT_STATUS_REPORT",
                name: "View",
                value: false,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    title: i18n.t('common.settings'),
    menus: [
      {
        name: "Settings",
        items: [
          {
            title: i18n.t('utils.settingsPermission'),
            data: [
              {
                key: "SETTINGS_VIEW",
                name: "View and Modify",
                value: false,
              },

            ],
          },
        ],
      },
    ]
  },
])

const AdminUserPermissions = {
  DASHBOARD_VIEW: "DASHBOARD_VIEW",
  CUSTOMER_VIEW: "CUSTOMER_VIEW",
  CUSTOMER_ADD: "CUSTOMER_ADD",
  CUSTOMER_EDIT: "CUSTOMER_EDIT",
  CUSTOMER_DELETE: "CUSTOMER_DELETE",
  CUSTOMER_RESTORE: "CUSTOMER_RESTORE",
  CUSTOMER_SALES_ORDER_VIEW: "CUSTOMER_SALES_ORDER_VIEW",
  CUSTOMER_SALES_ORDER_ADD: "CUSTOMER_SALES_ORDER_ADD",
  CUSTOMER_SALES_ORDER_UPDATE: "CUSTOMER_SALES_ORDER_UPDATE",
  CUSTOMER_SALES_ORDER_DELETE: "CUSTOMER_SALES_ORDER_DELETE",
  CUSTOMER_PAUSE_VIEW: "CUSTOMER_PAUSE_VIEW",
  CUSTOMER_DISLIKE_VIEW: "CUSTOMER_DISLIKE_VIEW",
  CUSTOMER_ALLERGIES_VIEW: "CUSTOMER_ALLERGIES_VIEW",
  CUSTOMER_MEAL_VIEW: "CUSTOMER_MEAL_VIEW",
  PAYMENT_VIEW: "PAYMENT_VIEW",
  CUSTOMER_MEAL_RATING_VIEW: "CUSTOMER_MEAL_RATING_VIEW",
  CUSTOMER_DIETITIAN_VIEW: "CUSTOMER_DIETITIAN_VIEW",
  CUSTOMER_DELIVERY_SCHEDULE_VIEW: "CUSTOMER_DELIVERY_SCHEDULE_VIEW",
  IN_ACTIVE_CUSTOMER_VIEW: "IN_ACTIVE_CUSTOMER_VIEW",
  PAYMENT_OFFLINE: "PAYMENT_OFFLINE",
  PAYMENT_ONLINE: "PAYMENT_ONLINE",
  PAYMENT_FREE: "PAYMENT_FREE",
  PAYMENT_PAY_LATER: "PAYMENT_PAY_LATER",
  SALES_ORDER_VIEW: "SALES_ORDER_VIEW",
  SALES_ORDER_EXPORT: "SALES_ORDER_EXPORT",
  SALES_ORDER_DAY_WISE_VIEW: "SALES_ORDER_DAY_WISE_VIEW",
  END_DATE_REMINDER_VIEW: "END_DATE_REMINDER_VIEW",
  SALES_ORDER_DISCOUNT: "SALES_ORDER_DISCOUNT",
  INACTIVE_SALES_ORDER_VIEW: "INACTIVE_SALES_ORDER_VIEW",
  INACTIVE_SALES_ORDER_COUNT_VIEW: "INACTIVE_SALES_ORDER_COUNT_VIEW",
  MEALS_RATING_VIEW: "MEALS_RATING_VIEW",
  PUSH_NOTIFICATION_VIEW: "PUSH_NOTIFICATION_VIEW",
  PUSH_NOTIFICATION_SEND: "PUSH_NOTIFICATION_SEND",
  STOCK_VIEW: "STOCK_VIEW",
  STOCK_INWARD_VIEW: "STOCK_INWARD_VIEW",
  STOCK_OUTWARD_VIEW: "STOCK_OUTWARD_VIEW",
  STOCK_CURRENT_VIEW: "STOCK_CURRENT_VIEW",
  PURCHASE_VIEW: "PURCHASE_VIEW",
  PURCHASE_ADD: "PURCHASE_ADD",
  PURCHASE_SUBMIT: "PURCHASE_SUBMIT",
  ADJUST_STOCK_VIEW: "ADJUST_STOCK_VIEW",
  ADJUST_STOCK: "ADJUST_STOCK",
  MASTER_DATA_VIEW: "MASTER_DATA_VIEW",
  MASTER_DATA_ADD: "MASTER_DATA_ADD",
  MASTER_DATA_EDIT: "MASTER_DATA_EDIT",
  MASTER_DATA_DELETE: "MASTER_DATA_DELETE",
  MONTHLY_USAGE_VIEW: "MONTHLY_USAGE_VIEW",
  MONTHLY_PURCHASE_VIEW: "MONTHLY_PURCHASE_VIEW",
  PLAN_VIEW: "PLAN_VIEW",
  PLAN_ADD: "PLAN_ADD",
  PLAN_EDIT: "PLAN_EDIT",
  PLAN_DELETE: "PLAN_DELETE",
  PLAN_DUPLICATE: "PLAN_DUPLICATE",
  MEAL_VIEW: "MEAL_VIEW",
  MEAL_ADD: "MEAL_ADD",
  MEAL_EDIT: "MEAL_EDIT",
  MEAL_DELETE: "MEAL_DELETE",
  MEAL_DUPLICATE: "MEAL_DUPLICATE",
  MEAL_EXPORT: "MEAL_EXPORT",
  MEAL_STATUS: "MEAL_STATUS",
  MEALS_CATEGORY_VIEW: "MEALS_CATEGORY_VIEW",
  MEALS_CATEGORY_ADD: "MEALS_CATEGORY_ADD",
  MEALS_CATEGORY_EDIT: "MEALS_CATEGORY_EDIT",
  MEALS_CATEGORY_DELETE: "MEALS_CATEGORY_DELETE",
  DIET_PLAN_VIEW: "DIET_PLAN_VIEW",
  DIET_PLAN_ADD: "DIET_PLAN_ADD",
  DIET_PLAN_EDIT: "DIET_PLAN_EDIT",
  DIET_PLAN_DELETE: "DIET_PLAN_DELETE",
  DIETITIAN_APPOINTMENT_VIEW: "DIETITIAN_APPOINTMENT_VIEW",
  DIETITIAN_APPOINTMENT_EDIT: "DIETITIAN_APPOINTMENT_EDIT",
  DIETITIAN_APPOINTMENT_DELETE: "DIETITIAN_APPOINTMENT_DELETE",
  UNIVERSAL_PAUSE_VIEW: "UNIVERSAL_PAUSE_VIEW",
  UNIVERSAL_PAUSE_ADD: "UNIVERSAL_PAUSE_ADD",
  UNIVERSAL_PAUSE_DELETE: "UNIVERSAL_PAUSE_DELETE",
  PLAN_SWITCH_VIEW: "PLAN_SWITCH_VIEW",
  PLAN_SWITCH_ADD: "PLAN_SWITCH_ADD",
  PLAN_SWITCH_DELETE: "PLAN_SWITCH_DELETE",
  SWITCH_PLAN: "SWITCH_PLAN",
  MANAGER_VIEW: "MANAGER_VIEW",
  MANAGER_ADD: "MANAGER_ADD",
  MANAGER_EDIT: "MANAGER_EDIT",
  MANAGER_DELETE: "MANAGER_DELETE",
  ADMIN_VIEW: "ADMIN_VIEW",
  ADMIN_ADD: "ADMIN_ADD",
  ADMIN_EDIT: "ADMIN_EDIT",
  ADMIN_DELETE: "ADMIN_DELETE",
  PERMISSION_VIEW: "PERMISSION_VIEW",
  PERMISSION_ADD: "PERMISSION_ADD",
  PERMISSION_EDIT: "PERMISSION_EDIT",
  PERMISSION_DELETE: "PERMISSION_DELETE",
  DRIVER_VIEW: "DRIVER_VIEW",
  DRIVER_ADD: "DRIVER_ADD",
  DRIVER_EDIT: "DRIVER_EDIT",
  DRIVER_DELETE: "DRIVER_DELETE",
  DIETITIAN_VIEW: "DIETITIAN_VIEW",
  DIETITIAN_ADD: "DIETITIAN_ADD",
  DIETITIAN_EDIT: "DIETITIAN_EDIT",
  DIETITIAN_DELETE: "DIETITIAN_DELETE",
  CELEBRITY_VIEW: "CELEBRITY_VIEW",
  CELEBRITY_ADD: "CELEBRITY_ADD",
  CELEBRITY_EDIT: "CELEBRITY_EDIT",
  CELEBRITY_DELETE: "CELEBRITY_DELETE",
  LOCATION_VIEW: "LOCATION_VIEW",
  LOCATION_ADD: "LOCATION_ADD",
  LOCATION_EDIT: "LOCATION_EDIT",
  LOCATION_DELETE: "LOCATION_DELETE",
  REGION_VIEW: "REGION_VIEW",
  REGION_ADD: "REGION_ADD",
  REGION_EDIT: "REGION_EDIT",
  REGION_DELETE: "REGION_DELETE",
  TAX_SETTINGS: "TAX_SETTINGS",
  CUSTOMER_TAG_VIEW: "CUSTOMER_TAG_VIEW",
  CUSTOMER_TAG_ADD: "CUSTOMER_TAG_ADD",
  CUSTOMER_TAG_EDIT: "CUSTOMER_TAG_EDIT",
  CUSTOMER_TAG_DELETE: "CUSTOMER_TAG_DELETE",
  MEAL_TAG_VIEW: "MEAL_TAG_VIEW",
  MEAL_TAG_ADD: "MEAL_TAG_ADD",
  MEAL_TAG_EDIT: "MEAL_TAG_EDIT",
  MEAL_TAG_DELETE: "MEAL_TAG_DELETE",
  REFERRAL_VIEW: "REFERRAL_VIEW",
  REFERRAL_SETTINGS: "REFERRAL_SETTINGS",
  FAQ_VIEW: "FAQ_VIEW",
  FAQ_ADD: "FAQ_ADD",
  FAQ_EDIT: "FAQ_EDIT",
  FAQ_DELETE: "FAQ_DELETE",
  CONTACT_VIEW: "CONTACT_VIEW",
  CONTACT_ADD: "CONTACT_ADD",
  CONTACT_EDIT: "CONTACT_EDIT",
  CONTACT_DELETE: "CONTACT_DELETE",
  PROMO_CODE_VIEW: "PROMO_CODE_VIEW",
  PROMO_CODE_ADD: "PROMO_CODE_ADD",
  PROMO_CODE_EDIT: "PROMO_CODE_EDIT",
  PROMO_CODE_DELETE: "PROMO_CODE_DELETE",
  OFFER_VIEW: "OFFER_VIEW",
  OFFER_ADD: "OFFER_ADD",
  OFFER_EDIT: "OFFER_EDIT",
  OFFER_DELETE: "OFFER_DELETE",
  SETTINGS_VIEW: "SETTINGS_VIEW",
  ORDER_ITEM_VIEW: "ORDER_ITEM_VIEW",
  GENERATE_ITEMS: "GENERATE_ITEMS",
  INGREDIENT_VIEW: "INGREDIENT_VIEW",
  MEALS_VIEW: "MEALS_VIEW",
  DELIVERY_REPORT_VIEW: "DELIVERY_REPORT_VIEW",
  DELIVERY_REPORT_GENERATE: "DELIVERY_REPORT_GENERATE",
  DELIVERY_REPORT_REGENERATE: "DELIVERY_REPORT_REGENERATE",
  DELIVERY_STATUS_UPDATE: "DELIVERY_STATUS_UPDATE",
  SET_MENU_REPORT_VIEW: "SET_MENU_REPORT_VIEW",
  QUICK_DELIVERY_REPORT_VIEW: "QUICK_DELIVERY_REPORT_VIEW",
  QUICK_VIEW_GENERATE: "QUICK_VIEW_GENERATE",
  QUICK_VIEW_REGENERATE: "QUICK_VIEW_REGENERATE",
  SALES_REPORT_VIEW: "SALES_REPORT_VIEW",
  DRIVER_REPORT_VIEW: "DRIVER_REPORT_VIEW",
  PROMO_CODE_REPORT_VIEW: "PROMO_CODE_REPORT_VIEW",
  PAUSED_MEALS_REPORT_VIEW: "PAUSED_MEALS_REPORT_VIEW",
  MONTHLY_SALES_VIEW: "MONTHLY_SALES_VIEW",
  CUSTOMER_HEALTH_INFO_VIEW: "CUSTOMER_HEALTH_INFO_VIEW",
  CUSTOMER_HEALTH_INFO_ADD: "CUSTOMER_HEALTH_INFO_ADD",
  CUSTOMER_HEALTH_INFO_EDIT: "CUSTOMER_HEALTH_INFO_EDIT",
  DIETITIAN_APPOINTMENTS_REPORT: "DIETITIAN_APPOINTMENTS_REPORT",
  CUSTOMER_WITHOUT_MEAL_VIEW: "CUSTOMER_WITHOUT_MEAL_VIEW",
  CUSTOMER_BIRTHDAY_REPORT_VIEW: "CUSTOMER_BIRTHDAY_REPORT_VIEW",
  DIETITIAN_SETTINGS: "DIETITIAN_SETTINGS",
  EXPORT_STATUS_REPORT: "EXPORT_STATUS_REPORT",
  MEAL_DETAILS_VIEW: "MEAL_DETAILS_VIEW",
  REFUND_REPORT: "REFUND_REPORT",
  UNIT_STOCK_VIEW: "UNIT_STOCK_VIEW",
  UNIT_STOCK_ADD: "UNIT_STOCK_ADD",
  UNIT_STOCK_EDIT: "UNIT_STOCK_EDIT",
  BRAND_STOCK_VIEW: "BRAND_STOCK_VIEW",
  BRAND_STOCK_ADD: "BRAND_STOCK_ADD",
  BRAND_STOCK_EDIT: "BRAND_STOCK_EDIT",
  SUPPLIER_STOCK_DELETE: "SUPPLIER_STOCK_DELETE",
  SUPPLIER_STOCK_EDIT: "SUPPLIER_STOCK_EDIT",
  SUPPLIER_STOCK_ADD: "SUPPLIER_STOCK_ADD",
  SUPPLIER_STOCK_VIEW: "SUPPLIER_STOCK_VIEW",
  PLAN_TRANSFER_LIST: "PLAN_TRANSFER_LIST",
  // DIET_PLAN_VIEW: "DIET_PLAN_VIEW",
  // DIET_PLAN_ADD: "DIET_PLAN_ADD",
  // DIET_PLAN_EDIT: "DIET_PLAN_EDIT",
  // DIET_PLAN_DELETE: "DIET_PLAN_DELETE",

  SHOP_PRODUCT_VIEW: "SHOP_PRODUCT_VIEW",
  SHOP_PRODUCT_ADD: "SHOP_PRODUCT_ADD",
  SHOP_PRODUCT_EDIT: "SHOP_PRODUCT_EDIT",
  SHOP_PRODUCT_DELETE: "SHOP_PRODUCT_DELETE",

  SHOP_ORDER_VIEW: "SHOP_ORDER_VIEW",
  SHOP_ORDER_UPDATE: "SHOP_ORDER_UPDATE",
  SHOP_ORDER_PLACE: "SHOP_ORDER_PLACE",
  CONTACT_US_VIEW: "CONTACT_US_VIEW",
  ARTICLE_VIEW: "ARTICLE_VIEW",
  HOME_PAGE_SETTINGS: "HOME_PAGE_SETTINGS",
  DIETITIAN_PLAN_SUGGESTION: "DIETITIAN_PLAN_SUGGESTION",

}
/*
 * SaaS plan gate (SAAS-REVAMP/DESIGN.md §8.5): permission keys that belong to exactly one
 * optional plan feature. While that feature is not in the tenant's plan the key reads as not
 * granted — for ADMIN too — which hides the buttons, tabs and menu entries it guards.
 * Keys that also guard unrelated pages are deliberately left out (FAQ_VIEW guards Refund /
 * Article / Gateway charges / Home page, CELEBRITY_VIEW guards staff-info, PLAN_TRANSFER_LIST
 * guards Contact us, PROMO_CODE_VIEW/ADD/EDIT/DELETE guard the shop discounts page,
 * CUSTOMER_HEALTH_INFO_EDIT guards a shop category form): those pages are gated by their
 * route's meta.feature instead. Also left out: UNIT_STOCK_*, BRAND_STOCK_* and SUPPLIER_STOCK_*
 * (units, brands and vendors feed the core ingredient master), EXPORT_STATUS_REPORT (the
 * report-status page also serves the kitchen sticker / delivery-sheet downloads) and PERMISSION_*
 * (roles are core: adding any staff user needs one). Wind-down rule (DESIGN §8.2): the keys that
 * read or close out EXISTING records stay unmapped on every plan — UNIVERSAL_PAUSE_VIEW/DELETE,
 * SHOP_ORDER_VIEW/UPDATE, DIETITIAN_APPOINTMENT_VIEW/EDIT/DELETE, DIETITIAN_APPOINTMENTS_REPORT;
 * creating new ones (UNIVERSAL_PAUSE_ADD, SHOP_ORDER_PLACE, ...) stays gated.
 */
const PERMISSION_FEATURES = {
  STOCK_VIEW: "inventory",
  STOCK_INWARD_VIEW: "inventory",
  STOCK_OUTWARD_VIEW: "inventory",
  STOCK_CURRENT_VIEW: "inventory",
  PURCHASE_VIEW: "inventory",
  PURCHASE_ADD: "inventory",
  PURCHASE_SUBMIT: "inventory",
  ADJUST_STOCK_VIEW: "inventory",
  ADJUST_STOCK: "inventory",
  MONTHLY_USAGE_VIEW: "inventory",
  MONTHLY_PURCHASE_VIEW: "inventory",
  UNIVERSAL_PAUSE_ADD: "universal_pause",
  PLAN_SWITCH_VIEW: "plan_switch",
  PLAN_SWITCH_ADD: "plan_switch",
  PLAN_SWITCH_DELETE: "plan_switch",
  SWITCH_PLAN: "plan_switch",
  PAYMENT_PAY_LATER: "pay_later",
  SET_MENU_REPORT_VIEW: "set_menu",
  PROMO_CODE_REPORT_VIEW: "promo_codes",
  OFFER_VIEW: "offers",
  OFFER_ADD: "offers",
  OFFER_EDIT: "offers",
  OFFER_DELETE: "offers",
  REFERRAL_VIEW: "referral_program",
  REFERRAL_SETTINGS: "referral_program",
  CELEBRITY_ADD: "celebrity",
  CELEBRITY_EDIT: "celebrity",
  CELEBRITY_DELETE: "celebrity",
  PUSH_NOTIFICATION_VIEW: "push_notifications",
  PUSH_NOTIFICATION_SEND: "push_notifications",
  ARTICLE_VIEW: "web_storefront",
  HOME_PAGE_SETTINGS: "web_storefront",
  SHOP_PRODUCT_VIEW: "shop",
  SHOP_PRODUCT_ADD: "shop",
  SHOP_PRODUCT_EDIT: "shop",
  SHOP_PRODUCT_DELETE: "shop",
  SHOP_ORDER_PLACE: "shop",
  DIETITIAN_VIEW: "dietitian_clinic",
  DIETITIAN_ADD: "dietitian_clinic",
  DIETITIAN_EDIT: "dietitian_clinic",
  DIETITIAN_DELETE: "dietitian_clinic",
  DIETITIAN_SETTINGS: "dietitian_clinic",
  DIETITIAN_PLAN_SUGGESTION: "dietitian_clinic",
  CUSTOMER_DIETITIAN_VIEW: "dietitian_clinic",
  CUSTOMER_HEALTH_INFO_VIEW: "health_profile",
  CUSTOMER_HEALTH_INFO_ADD: "health_profile",
  SALES_ORDER_EXPORT: "excel_export",
  MEAL_EXPORT: "excel_export",
  MONTHLY_SALES_VIEW: "advanced_reports",
  CUSTOMER_BIRTHDAY_REPORT_VIEW: "advanced_reports",
}

/** False when the permission belongs to a plan feature the tenant's plan does not include. */
const isPermissionInPlan = (key) => {
  const feature = Object.prototype.hasOwnProperty.call(PERMISSION_FEATURES, key) ? PERMISSION_FEATURES[key] : null
  return !feature || hasFeature(feature)
}

/**
 * The role editor's tree (getUserRoles()) without the permissions of features the plan lacks, so
 * a role cannot be granted them; menus and groups left empty are dropped.
 */
const filterRoleTreeByPlan = (tree) => tree
  .map(group => ({
    ...group,
    menus: group.menus
      .map(menu => ({
        ...menu,
        items: menu.items
          .map(item => ({ ...item, data: item.data.filter(permission => isPermissionInPlan(permission.key)) }))
          .filter(item => item.data.length > 0),
      }))
      .filter(menu => menu.items.length > 0),
  }))
  .filter(group => group.menus.length > 0)

export { getUserRoles, AdminUserPermissions, PERMISSION_FEATURES, isPermissionInPlan, filterRoleTreeByPlan }
export class UserRoleSettings {
  hasRole(role) {
    if (!isPermissionInPlan(role)) return false;
    let userRoles = localStorage.getItem("DONE_USER_ROLE_PERMISSIONS")
    let isAdmin = localStorage.getItem("DONE_USER_ROLE") == "ADMIN" ? true : false;
    if (userRoles) {
      let parsedRoles = JSON.parse(userRoles);
      if (parsedRoles.includes(role)) {
        return true;
      }
    }
    return isAdmin;
  }
}
